import './App.css';
import Logo from "./icons8-peacock-feather-96.png";
import { Plus, MessageSquare, AlignCenter, Send } from "lucide-react";
import { sendMsg } from './components/GPT';
import { useState } from 'react';
import Mandala from "./pngtree-yellow-mandala-art-png-image_8646011.png"
import Arjuna from "./Arjuna.png"
import Krishna from "./Krishna.png"
import Icon from "./Krishna-icon.png"


function App() {
  const [input, setInput] = useState("");
  const [face,setFace] = useState(true)
  const [messages, setMessages] = useState([
    {
      text: "Greetings, seeker of wisdom. I am the Gita AI, a digital representation infused with the timeless teachings of the Bhagavad Gita. If you seek guidance, I am here to illuminate the path of righteousness with insights that transcend time. How may I assist you on your journey, dear seeker?",
      isBot: true,
      role: "Gita AI"
    }
  ]);
  const NewChat = () =>{
    return(
      setMessages([{
        text:"Greetings, seeker of wisdom. I am the Gita AI, a digital representation infused with the timeless teachings of the Bhagavad Gita. If you seek guidance, I am here to illuminate the path of righteousness with insights that transcend time. How may I assist you on your journey, dear seeker?",
      isBot:true,
      role:"Gita AI"}
      ])
    )
  }
  const depression= async () =>{
    const res = await sendMsg("How to overcome depression?")
    setMessages([...messages,
    {
      text:"How to overcome depression?",isBot:false,role:"You"
    },
    {
      text:res,isBot:true,role:"Gita AI"
    }
    ])
  }
  const perspective= async () =>{
    const res = await sendMsg("What is the perspective of life")
    setMessages([...messages,
    {
      text:"What is the perspective of life?",isBot:false,role:"You"
    },
    {
      text:res,isBot:true,role:"Gita AI"
    }
    ])
  }

  const currentDate = new Date();
  let hour = currentDate.getHours();
  const minutes = currentDate.getMinutes();
  const ampm = hour >= 12 ? 'PM' : 'AM';
  hour = hour % 12;
  hour = hour ? hour : 12; // the hour '0' should be '12'
  const formattedMinutes = minutes < 10 ? '0'+minutes : minutes;
  const currentTime = `${hour}:${formattedMinutes} ${ampm}`;

  const handleSend = async () => {
    const text = input;
    setInput('');
    const res = await sendMsg(text);
    setMessages(messages => [...messages, { text, isBot: false, role: "You" }, { text: res, isBot: true, role: "Gita AI" }]);
  };
  setTimeout(()=>{
    setFace(false)
  },4000)


  return face? (
  <div className='loader h-screen w-screen flex-col flex justify-center items-center bg-white'>
    <img className='mandala w-[30%] h-auto' src={Mandala} alt="" />
    <h1 className='text-xl'>Loading Gita AI<span className='animate'></span></h1>
  </div>
  ) : (
    <div className='h-[90vh] bg-white w-[90vw]'>
      <div className="app flex bg-white flex-col">
        <div className='mobnav z-[110]'>
        <div className="drawer z-[100]">
  <input id="my-drawer" type="checkbox" className="drawer-toggle" />
  <div className="drawer-content">
    {/* Page content here */}
    
  </div> 
  <div className="drawer-side">
    <label htmlFor="my-drawer" aria-label="close sidebar" className="drawer-overlay"></label>
    <div className="menu z-[100] p-4 w-80 min-h-full bg-white text-base-content">
    <h1 className="text-4xl font-bold flex justify-center items-center mb-10">
    <img src={Icon} alt="" height={60} width={60} /> Gita AI
          </h1>
          <button onClick={NewChat} className="btn bg-orange-400 hover:bg-orange-600 text-white border-none flex justify-center items-center w-full mb-32">
            <Plus fill="white" />New chat
          </button>
          <button onClick={(e) => {e.preventDefault(); depression();}} className="btn btn-outline m-2 ml-0 w-full border-orange-400 text-orange-400 hover:bg-orange-600 hover:text-white justify-start">
  <div className="flex justify-center items-center">
    <MessageSquare />How to overcome depression?
  </div>
  </button>
  <button onClick={(e) => {e.preventDefault(); perspective();}} className="btn btn-outline m-2 w-full ml-0 border-orange-400 hover:bg-orange-600 hover:text-white text-orange-400 justify-start">
  <div className="flex justify-center items-center">
    <MessageSquare />What is the perspective of life?
  </div>
</button>
    </div>
  </div>
</div>

          </div>
        
        <div className="main w-90 bg-white flex flex-col">
          <div className="navbar bg-white sticky top-0 flex h-10 justify-between z-30  p-4">
            <a href="." className="btn btn-ghost text-black text-3xl">
              <img src={Icon} alt="" width={40} height={40} /> Gita AI
            </a>
            <label htmlFor="my-drawer" className="btn btn-primary bg-orange-400 text-white hover:bg-orange-600 border-none drawer-button"><AlignCenter/></label>
          </div>
         
          <div className="msgarea bg-white overflow-y-scroll scroll flex flex-col">
            <div className="chats bg-white text-black overflow-y-scroll mb-2 ">
              {messages.map((message, i) => (
                <div key={i} className={`chat ${message.isBot ? "chat-start text-black" : "chat-end text-black"}`}>
                  <div className="chat-image avatar">
                    <div className="w-16">
                      <img className='w-16 object-fill' src={message.isBot ? Krishna:Arjuna} alt="" />
                    </div>
                  </div>
                  <div className="chat-header font-semibold text-black">
                    {message.role} 
                    <time className="text-xs text-orange-600 opacity-50"> {currentTime}</time>
                  </div>
                  <div className="chat-bubble bg-gray-100 text-black">{message.text}</div>
                </div>
              ))}
              <div className='dwarf bg-white h-[8vh]'>

              </div>
            </div>
            
            <div className="footer h-[10vh] flex bg-gray-100 justify-center items-center p-3">
              <input placeholder="Ask here" value={input} onChange={(e) => setInput(e.target.value)} type="text" className="input input-bordered border-orange-400 text-black bg-white w-full mx-2" />
              <button onClick={handleSend} className="btn border-none bg-orange-400 text-white flex justify-center items-center mb-1">
                <Send />
              </button>
            </div>
          </div>
        </div>
        
            </div>

    </div>
  )}
export default App;
